module.exports = __webpack_public_path__ + "img/image4.bb5e3ebc.jpg";